module.exports = __webpack_public_path__ + "img/LogoTelmex_Color.d279bf63.png";